import { render, staticRenderFns } from "./FileArrowUpIcon.vue?vue&type=template&id=53df0f49&"
import script from "./FileArrowUpIcon.vue?vue&type=script&lang=js&"
export * from "./FileArrowUpIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports